export class StatusItem {
    constructor() { }
    value:string;
    name:string;
}


// WEBPACK FOOTER //
// ./src/app/modules/mailing-list/models/status-item.ts